import styled from 'styled-components';

import Text from '~components/Text';
import { getFontStyle } from '~components/Text/helper';

export const S = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    flex: 1;

    ${({ theme }) => theme.media.mobile} {
      text-align: center;

      & > span:first-child {
        ${getFontStyle('bold150_H5')}
      }
    }

    & a {
      color: ${({ theme }) => theme.colors.greymint300};
    }

    & svg {
      margin-bottom: 2px;
    }
  `,
  CompanyName: styled(Text)`
    margin: 12px 0px 6px;
  `,
  CompanyInfoItem: styled.div`
    display: flex;
    margin-top: 2px;
    margin-bottom: 4px;
    align-items: center;

    svg {
      margin-right: 5px;
    }

    img {
      width: 2px;
      height: 2px;
      margin-left: 8px;
      margin-right: 9.5px;
    }

    ${({ theme }) => theme.media.with('mobile', 'tablet')} {
      flex-direction: column;
      margin-bottom: 8px;
    }

    ${({ theme }) => theme.media.tablet} {
      align-items: flex-start;
    }
  `,
  TextItem: styled.div`
    display: flex;
    align-items: center;
  `,
};
